import React from 'react';
import { observer } from 'mobx-react';

import Styled from 'styled';

import { Buyer } from 'four-nets/bazaar/bazaar';

import BuyerView from './buyer-view';
import defaultStyles from './buyers-view.scss';
import { FormattedMessage } from 'react-intl';

export interface Props {
    identifiers: Buyer[];
    current?: string;
    column?: number | boolean;
    styles: typeof defaultStyles;
}

interface State {
    showCanceled: boolean;
}

@observer
class BuyersView extends React.Component<Props, State> {
    static defaultProps = {
        column: false,
        identifiers: [],
    };

    state = { showCanceled: false };

    render() {
        const { styles, column } = this.props;
        const { showCanceled } = this.state;

        const classNames = [styles.mainWrapper];
        if (column) {
            classNames.push(styles.column);
        }
        return (
            <>
                <div className={classNames.join(' ')}>
                    {this.props.identifiers.map((buyer, index) => (
                        <BuyerView
                            key={buyer.username}
                            buyer={buyer}
                            index={index}
                            column={column}
                            messagesCount={buyer.messagesCount}
                            newMessagesCount={buyer.newMessagesCount}
                            createdDate={buyer.createdDate}
                            current={Boolean(this.props.current && this.props.current === buyer.username)}
                            showCanceled={showCanceled}
                        />
                    ))}
                </div>
                <button
                    className={styles.button}
                    onClick={() => {
                        this.setState(prev => ({
                            showCanceled: !prev.showCanceled,
                        }));
                    }}
                >
                    {showCanceled ? (
                        <FormattedMessage id='HIDE_CANCELED_BUYERS' />
                    ) : (
                        <FormattedMessage id='SHOW_CANCELED_BUYERS' />
                    )}
                </button>
            </>
        );
    }
}

export default Styled(defaultStyles)(BuyersView);
